document.addEventListener("DOMContentLoaded", function () {
  const btn = document.getElementById("find-in-store-btn");
  const modal = document.getElementById("find-in-store-modal");
  const variantDataScript = document.getElementById("product-variants-json");
  const brandDataScript = document.getElementById("product-brand-json");

  if (!btn || !modal || !variantDataScript) {
    return;
  }

  function disableBodyScroll() {
    // Calculate the width of the scrollbar
    const scrollbarWidth =
      window.innerWidth - document.documentElement.clientWidth;
    // Add padding to the body to avoid content shift
    document.body.style.paddingRight = `${scrollbarWidth}px`;
    // Add the class to hide the overflow
    document.body.classList.add("modal-open-no-scroll");
  }

  function enableBodyScroll() {
    // Remove the class to restore overflow
    document.body.classList.remove("modal-open-no-scroll");
    // Remove the inline padding
    document.body.style.paddingRight = "";
  }

  let isGoogleMapsApiLoaded = false;

  // Extract API base URL from maps API URL or use data attribute
  const mapsApiUrl = modal.dataset.mapsApiUrl || "";
  let apiBaseUrl = modal.dataset.apiUrl;

  // If no explicit API URL, extract from maps API URL
  if (!apiBaseUrl && mapsApiUrl) {
    try {
      const url = new URL(mapsApiUrl);
      apiBaseUrl = `${url.protocol}//${url.host}`;
    } catch (e) {
      // Fallback: try to extract from string
      const match = mapsApiUrl.match(/https?:\/\/[^\/]+/);
      if (match) {
        apiBaseUrl = match[0];
      }
    }
  }

  // Final fallback (shouldn't be needed if maps API URL is set)
  if (!apiBaseUrl) {
    apiBaseUrl = window.location.origin;
  }

  // Read brand from embedded JSON — defaults to "REFINERY"
  let brand = "REFINERY";
  if (brandDataScript) {
    try {
      brand = JSON.parse(brandDataScript.textContent.trim());
    } catch (e) {
      brand = "REFINERY";
    }
  }

  // Main application state
  const state = {
    shopDomain: modal.dataset.shopDomain,
    brand: brand,
    allVariants: JSON.parse(variantDataScript.textContent),
    productOptions: [],
    selectedOptions: [],
    currentSku: null,
    lastSearchType: null,
    lastLocation: null,
    autocomplete: null,
    modalOpenTime: null,
    apiBaseUrl: apiBaseUrl, // Store API base URL
  };

  function getOrCreateSessionId() {
    let sid = sessionStorage.getItem('fis_session_id');
    if (!sid) {
      sid = 'session_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
      sessionStorage.setItem('fis_session_id', sid);
    }
    return sid;
  }

  function trackAnalyticsEvent(eventType, additionalData = {}) {
    const data = {
      eventType,
      shopDomain: state.shopDomain,
      brand: state.brand,
      sessionId: getOrCreateSessionId(),
      sku: state.currentSku,
      variant: state.selectedOptions.length > 0 ? state.selectedOptions : null,
      userAgent: navigator.userAgent,
      referrer: document.referrer,
      ...additionalData
    };

    const url = `${state.apiBaseUrl}/api/analytics/track`;
    
    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
      keepalive: true // Ensure request completes even if user navigates away
    }).catch(e => { /* Ignore tracking errors */ });
  }

  // Track product page view immediately on load
  trackAnalyticsEvent("product_page_view");



  const elements = {
    closeBtn: modal.querySelector(".find-in-store-close"),
    resultsContainer: document.getElementById("find-in-store-results"),
    variantSelectorContainer: document.getElementById(
      "fis-variant-selector-container"
    ),
  };

  const infoIconSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>`;
  const preloaderSvg = `<svg class="preloader-spinner" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a9 9 0 1 1-6.219-8.56"/></svg>`;

  // --- Variant Picker Logic ---

  function initVariantSelector() {
    state.productOptions = state.allVariants[0].options.map((opt) =>
      typeof opt === "string" ? opt : opt.name
    );
    elements.variantSelectorContainer.innerHTML = "";
    const initialVariant =
      getVariantFromPage() || state.allVariants.find((v) => v.available);

    // ✅ Initialize our "source of truth" array with the starting variant's options
    if (initialVariant) {
      state.selectedOptions = [...initialVariant.options];
    }

    state.productOptions.forEach((optionName, index) => {
      const optionValues = [
        ...new Set(state.allVariants.map((v) => v.options[index])),
      ];

      if (optionValues.length > 1) {
        // Only render if there's a choice to be made
        const fieldset = document.createElement("fieldset");
        fieldset.className = "fis-variant-pills product-form__input";
        fieldset.dataset.index = index; // Store the true option index

        let variantTitle = optionName;
        variantTitle = "SELECT SIZE";

        const legend = document.createElement("legend");
        legend.className = "form__label";
        legend.textContent = variantTitle;
        fieldset.appendChild(legend);

        optionValues.forEach((value) => {
          const inputId = `fis-option-${index}-${value.replace(/\s+/g, "-")}`;
          const input = document.createElement("input");
          input.type = "radio";
          input.id = inputId;
          input.name = `fis-option-${index}`;
          input.value = value;

          if (state.selectedOptions[index] === value) {
            input.checked = true;
          }

          const label = document.createElement("label");
          label.htmlFor = inputId;
          label.textContent = value;

          fieldset.appendChild(input);
          fieldset.appendChild(label);
        });
        elements.variantSelectorContainer.appendChild(fieldset);
      }
    });

    updateVariantAvailability();
    updateCurrentSkuFromState();
    elements.variantSelectorContainer.addEventListener(
      "change",
      onVariantChange
    );
  }

  function getVariantFromPage() {
    const variantInput = document.querySelector(
      'input[name="id"], .product-variant-id'
    );
    if (!variantInput) return null;
    return state.allVariants.find((v) => v.id == variantInput.value);
  }

  function updateCurrentSkuFromState() {
    const foundVariant = state.allVariants.find((variant) =>
      variant.options.every(
        (opt, index) => opt === state.selectedOptions[index]
      )
    );
    state.currentSku = foundVariant ? foundVariant.sku : null;
    return !!foundVariant;
  }

  function updateVariantAvailability() {
    const fieldsets =
      elements.variantSelectorContainer.querySelectorAll("fieldset");
    fieldsets.forEach((fieldset) => {
      const index = parseInt(fieldset.dataset.index, 10);
      const inputs = fieldset.querySelectorAll('input[type="radio"]');

      inputs.forEach((input) => {
        const tempOptions = [...state.selectedOptions];
        tempOptions[index] = input.value;

        const isAvailable = state.allVariants.some((variant) =>
          variant.options.every(
            (opt, i) => tempOptions[i] === null || opt === tempOptions[i]
          )
        );
        input.disabled = !isAvailable;
      });
    });
  }

  function onVariantChange(event) {
    const fieldset = event.target.closest("fieldset");
    if (!fieldset) return;

    const index = parseInt(fieldset.dataset.index, 10);
    const value = event.target.value;
    state.selectedOptions[index] = value;

    updateVariantAvailability();
    if (updateCurrentSkuFromState()) {
      if (state.lastSearchType === "location" && state.lastLocation) {
        findStoresByLocation(state.lastLocation);
      } else {
        showLocationPrompt();
      }
    } else {
      showResults(
        `<div class="notice-box info">${infoIconSvg}<span>This combination is not available.</span></div>`
      );
    }
  }
  // --- API and Rendering Logic ---

  function runSearch() {
    const sku = state.currentSku;
    if (!sku) {
      showResults(
        `<div class="notice-box info">${infoIconSvg}<span>This product variant does not have a SKU.</span></div>`
      );
      return;
    }

    if (!state.lastLocation) {
      showLocationPrompt();
      return;
    }

    const body = {
      sku,
      shop: state.shopDomain,
      brand: state.brand,
      variant: state.selectedOptions.length > 0 ? state.selectedOptions : null,
      location: state.lastLocation,
    };

    fetch(`${state.apiBaseUrl}/api/find-in-store`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    })
      .then((res) => (res.ok ? res.json() : Promise.reject(res)))
      .then((data) => {
        if (data.stores && data.stores.length > 0) {
          data.stores.sort((a, b) => a.distance - b.distance);
          renderStoreList(data.stores, true);

          trackAnalyticsEvent("search_by_location", {
            resultsCount: data.stores.length,
            location: state.lastLocation,
          });
        } else {
          showResults(
            `<div class="notice-box info">${infoIconSvg}<span>This product is not currently available in stores near the selected location.</span></div>`
          );

          trackAnalyticsEvent("search_by_location", {
            resultsCount: 0,
            location: state.lastLocation,
          });
        }
      })
      .catch((err) => {
        handleError(err);
      });
  }

  function showLocationPrompt() {
    state.lastSearchType = null;
    showResults(
      `<div class="notice-box info">${infoIconSvg}<span>Enter an address or use your location to find stores with stock near you.</span></div>`
    );
  }

  function findStoresByLocation(location) {
    state.lastSearchType = "location";
    showResults(
      `<div class="notice-box info">${preloaderSvg}<span>Searching for stock near you...</span></div>`
    );
    resolveLocationWithLocality(location)
      .then((resolved) => {
        state.lastLocation = resolved;
        runSearch();
      })
      .catch(() => {
        showResults(
          `<div class="notice-box info">${infoIconSvg}<span>Could not resolve that location. Please try again or pick a suggestion from the list.</span></div>`
        );
      });
  }

  const SA_PROVINCE_ABBR = {
    "western cape": "WC",
    "eastern cape": "EC",
    "northern cape": "NC",
    "free state": "FS",
    gauteng: "GP",
    "kwazulu-natal": "KZN",
    limpopo: "LP",
    mpumalanga: "MP",
    "north west": "NW",
  };

  // Metro locality names Google often returns instead of the suburb (Bellville, Khayelitsha, …)
  const SA_METRO_LOCALITIES = {
    "cape town": true,
    "city of cape town": true,
    johannesburg: true,
    "city of johannesburg": true,
    pretoria: true,
    tshwane: true,
    "city of tshwane": true,
    durban: true,
    ethekwini: true,
  };

  function addressComponentName(components, type) {
    const match = (components || []).find(
      (c) => Array.isArray(c.types) && c.types.includes(type)
    );
    return match ? match.long_name : null;
  }

  function isMetroLocality(name) {
    return !!(name && SA_METRO_LOCALITIES[String(name).trim().toLowerCase()]);
  }

  /** Prefer suburb/township over metro city for analytics (e.g. Bellville not Cape Town). */
  function pickTownFromComponents(components) {
    const suburb =
      addressComponentName(components, "sublocality_level_1") ||
      addressComponentName(components, "sublocality_level_2") ||
      addressComponentName(components, "sublocality") ||
      addressComponentName(components, "neighborhood");
    const locality =
      addressComponentName(components, "locality") ||
      addressComponentName(components, "postal_town");
    const admin2 = addressComponentName(
      components,
      "administrative_area_level_2"
    );

    if (suburb) return suburb;
    if (locality && !isMetroLocality(locality)) return locality;
    if (admin2 && !isMetroLocality(admin2)) return admin2;
    return locality || admin2 || null;
  }

  function formatLocalityFromComponents(components) {
    const town = pickTownFromComponents(components);
    const provinceComponent = (components || []).find(
      (c) =>
        Array.isArray(c.types) && c.types.includes("administrative_area_level_1")
    );
    const provinceName = provinceComponent ? provinceComponent.long_name : null;
    const province =
      (provinceName && SA_PROVINCE_ABBR[provinceName.toLowerCase()]) ||
      (provinceComponent && provinceComponent.short_name) ||
      null;
    const postalCode = addressComponentName(components, "postal_code");
    return [town, province, postalCode].filter(Boolean).join(", ") || null;
  }

  function scoreLocalityLabel(label, components) {
    if (!label) return -1;
    let score = 0;
    const town = label.split(",")[0].trim();
    if (!isMetroLocality(town)) score += 5;
    if (addressComponentName(components, "sublocality_level_1")) score += 3;
    else if (addressComponentName(components, "sublocality")) score += 2;
    else if (addressComponentName(components, "neighborhood")) score += 2;
    if (addressComponentName(components, "postal_code")) score += 1;
    return score;
  }

  function pickBestLocalityFromGeocodeResults(results) {
    let bestLabel = null;
    let bestScore = -1;
    for (let i = 0; i < (results || []).length; i++) {
      const components = results[i].address_components;
      const label = formatLocalityFromComponents(components);
      const score = scoreLocalityLabel(label, components);
      if (score > bestScore) {
        bestScore = score;
        bestLabel = label;
      }
    }
    return bestLabel;
  }

  function reverseGeocodeLocalityBrowser(lat, lng) {
    return new Promise((resolve) => {
      if (
        typeof google === "undefined" ||
        !google.maps ||
        !google.maps.Geocoder
      ) {
        resolve(null);
        return;
      }
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({ location: { lat, lng } }, (results, status) => {
        if (status !== "OK" || !results || !results.length) {
          resolve(null);
          return;
        }
        resolve(pickBestLocalityFromGeocodeResults(results));
      });
    });
  }

  function geocodeAddressBrowser(address) {
    return new Promise((resolve, reject) => {
      if (
        typeof google === "undefined" ||
        !google.maps ||
        !google.maps.Geocoder
      ) {
        reject(new Error("Maps not loaded"));
        return;
      }
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode(
        { address, componentRestrictions: { country: "ZA" } },
        (results, status) => {
          if (status !== "OK" || !results || !results[0]) {
            reject(new Error("geocode failed"));
            return;
          }
          const result = results[0];
          const loc = result.geometry.location;
          const locality =
            pickBestLocalityFromGeocodeResults(results) ||
            formatLocalityFromComponents(result.address_components);
          resolve({
            latitude: loc.lat(),
            longitude: loc.lng(),
            locality,
          });
        }
      );
    });
  }

  /**
   * Autocomplete / Place Details already supply address_components → locality.
   * Only reverse-geocode when locality is missing (e.g. browser geolocation).
   * Geocoding is a separate Google SKU and cannot share an Autocomplete session.
   */
  async function resolveLocationWithLocality(location) {
    if (typeof location === "string") {
      return geocodeAddressBrowser(location);
    }
    if (
      location &&
      typeof location === "object" &&
      location.latitude != null &&
      location.longitude != null
    ) {
      if (
        typeof location.locality === "string" &&
        location.locality.trim()
      ) {
        return location;
      }
      const locality = await reverseGeocodeLocalityBrowser(
        Number(location.latitude),
        Number(location.longitude)
      );
      if (locality) return { ...location, locality };
    }
    return location;
  }

  function renderStoreList(stores, showDistance) {
    let listHtml = '<ul class="store-list">';
    stores.forEach((storeData, index) => {
      const { store, distance, quantity } = storeData;
      const storeId = store.name.replace(/[^a-zA-Z0-9]/g, "") + index;
      const distanceHtml = showDistance
        ? `<small>(${distance.toFixed(1)} km away)</small>`
        : "";
      const isLowStock = quantity <= 2;
      const availabilityMessage = isLowStock
        ? "Available for in-store purchase with low stock"
        : "Available for in-store purchase";
      const availabilityClass = isLowStock ? "low-stock" : "";

      listHtml += `
          <li class="store-list-item" id="store-item-${storeId}" data-store-name="${store.name.replace(
        /"/g,
        "&quot;"
      )}">
            <div class="store-summary">
              <div>
                <h4>${store.name} ${distanceHtml}</h4>
                <p>${store.address || "Address not available"}</p>
                <p class="store-availability ${availabilityClass}">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>
                  <span>${availabilityMessage}</span>
                </p>
              </div>
              <button class="store-details-toggle button button--tertiary" data-target="${storeId}">See More</button>
            </div>
            <div class="store-details-collapsible">
              <div class="store-details-map" id="map-for-${storeId}" data-lat="${
        store.latitude
      }" data-lng="${store.longitude}" data-name="${store.name}"></div>
              <div class="store-actions-grid">
                <a href="${
                  store.google_maps_url || "#"
                }" target="_blank" rel="noopener noreferrer" class="button button--primary">Directions</a>
                <a href="tel:${
                  store.contact_number || ""
                }" class="store-contact-link">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                  <span>${store.contact_number || "No Number"}</span>
                </a>
              </div>
              <h4 class="operating-hours-title">Opening Hours</h4>
              <div class="operating-hours-grid">${formatOperatingHours(
                store.operating_hours
              )}</div>
            </div>
          </li>`;
    });
    listHtml += "</ul>";
    showResults(listHtml);
  }

  function handleError(err) {
    console.error("Error searching:", err);
    showResults(
      `<div class="notice-box info">${infoIconSvg}<span>Sorry, an error occurred. Please try again.</span></div>`
    );
  }
  function showResults(html) {
    elements.resultsContainer.innerHTML = html;
  }
  function formatOperatingHours(hours) {
    if (!hours) return "<div>Hours not available.</div>";
    const daysOrder = [
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
      "sunday",
    ];
    const formatTime = (timeStr) =>
      typeof timeStr === "string" && timeStr.includes(":")
        ? timeStr.slice(0, 5)
        : "";
    const groupedHours = [];
    let currentGroup = null;
    daysOrder.forEach((day) => {
      const dayHours = hours[day];
      let timeRange = "Closed";
      if (dayHours) {
        if (dayHours.all_day) timeRange = "24 Hours";
        else if (dayHours.open && dayHours.close) {
          const openTime = formatTime(dayHours.open);
          const closeTime = formatTime(dayHours.close);
          if (openTime && closeTime) timeRange = `${openTime} - ${closeTime}`;
        }
      }
      if (!currentGroup || currentGroup.timeRange !== timeRange) {
        if (currentGroup) groupedHours.push(currentGroup);
        currentGroup = { days: [day], timeRange: timeRange };
      } else {
        currentGroup.days.push(day);
      }
    });
    if (currentGroup) groupedHours.push(currentGroup);
    const formatDayRange = (days) => {
      const capitalize = (s) => s.charAt(0).toUpperCase() + s.slice(1);
      if (days.length === 1) return capitalize(days[0]);
      return `${capitalize(days[0])} - ${capitalize(days[days.length - 1])}`;
    };
    let html = "";
    groupedHours.forEach((group) => {
      html += `<div>${formatDayRange(group.days)}</div> <div>${
        group.timeRange
      }</div>`;
    });
    return html || "<div>Hours not available.</div>";
  }

  function loadGoogleMapsApi(callback) {
    // If the 'google' object exists, the API is already loaded.
    if (typeof google !== "undefined" && google.maps) {
      isGoogleMapsApiLoaded = true;
      if (callback) callback();
      return;
    }

    // If we've already tried to load it, don't do it again.
    if (window.googleMapsApiLoading) return;

    window.googleMapsApiLoading = true;
    const mapsApiUrl = modal.dataset.mapsApiUrl;

    if (!mapsApiUrl) {
      console.error(
        "Maps API URL is not defined in data-maps-api-url attribute."
      );
      window.googleMapsApiLoading = false;
      return;
    }

    // Generate a unique callback name to avoid conflicts
    const callbackName = `gmapsCallback_${Date.now()}_${Math.random()
      .toString(36)
      .substr(2, 9)}`;
    const script = document.createElement("script");

    // Append callback parameter to the URL
    const urlWithCallback =
      mapsApiUrl +
      (mapsApiUrl.includes("?") ? "&" : "?") +
      `callback=${callbackName}`;
    script.src = urlWithCallback;
    script.async = true;
    script.defer = true;

    script.onerror = () => {
      if (script.parentNode) {
        document.head.removeChild(script);
      }
      delete window[callbackName];
      console.error("Failed to load the Google Maps API script.");
      window.googleMapsApiLoading = false;
    };

    // Set up the callback function
    window[callbackName] = () => {
      delete window[callbackName];
      if (!window.google || !google.maps) {
        console.error("Google Maps library not properly loaded");
        window.googleMapsApiLoading = false;
      } else {
        isGoogleMapsApiLoaded = true;
        window.googleMapsApiLoading = false;
        if (callback) callback();
      }
    };

    // Timeout fallback
    setTimeout(() => {
      if (!window.google || !google.maps) {
        if (script.parentNode) {
          document.head.removeChild(script);
        }
        delete window[callbackName];
        console.error("Google Maps loading timed out");
        window.googleMapsApiLoading = false;
      }
    }, 20000);

    document.head.appendChild(script);
  }

  function initMapForStore(mapElement) {
    if (
      typeof google === "undefined" ||
      mapElement.dataset.mapInitialized === "true"
    )
      return;
    const lat = parseFloat(mapElement.dataset.lat);
    const lng = parseFloat(mapElement.dataset.lng);
    const name = mapElement.dataset.name;

    const map = new google.maps.Map(mapElement, {
      center: { lat, lng },
      zoom: 15,
      disableDefaultUI: false, // Re-enable default UI
      zoomControl: true,
    });
    new google.maps.Marker({
      position: { lat, lng },
      map: map,
      title: name,
    });
    mapElement.dataset.mapInitialized = "true";
  }

  // --- Event Listeners ---

  btn.onclick = () => {
    state.modalOpenTime = Date.now();
    trackAnalyticsEvent("modal_opened");
    modal.style.display = "block";
    disableBodyScroll();
    initVariantSelector(); // Initialize the variant selectors
    showLocationPrompt();
    setTimeout(initAutocomplete, 100);
    loadGoogleMapsApi(initAutocomplete);
  };

  function closeModal() {
    if (state.modalOpenTime) {
      const duration = Math.round((Date.now() - state.modalOpenTime) / 1000);
      trackAnalyticsEvent("modal_closed", { duration });
    }
    modal.style.display = "none";
    enableBodyScroll();
    state.modalOpenTime = null;
  }

  elements.closeBtn.onclick = closeModal;
  window.onclick = (e) => {
    if (e.target == modal) {
      closeModal();
    }
  };

  elements.resultsContainer.addEventListener("click", function (e) {
    const toggleButton = e.target.closest(".store-details-toggle");
    if (toggleButton) {
      const storeId = toggleButton.dataset.target;
      const targetItem = document.getElementById(`store-item-${storeId}`);
      if (!targetItem) return;
      const isActive = targetItem.classList.contains("active");
      document.querySelectorAll(".store-list-item.active").forEach((item) => {
        if (item !== targetItem) {
          item.classList.remove("active");
          const otherButton = item.querySelector(".store-details-toggle");
          if (otherButton) otherButton.textContent = "See More";
        }
      });
      targetItem.classList.toggle("active");
      toggleButton.textContent = isActive ? "See More" : "See Less";
      if (!isActive) {
        const mapElement = targetItem.querySelector(".store-details-map");
        initMapForStore(mapElement);
      }
    }

    // Track directions clicks
    const directionsLink = e.target.closest('a[href*="maps.google.com"]');
    if (directionsLink) {
      const itemNode = e.target.closest(".store-list-item");
      const storeName = itemNode ? itemNode.dataset.storeName : null;
      trackAnalyticsEvent("directions_clicked", { storeName });
    }

    // Track phone clicks
    const phoneLink = e.target.closest('a[href^="tel:"]');
    if (phoneLink) {
      const itemNode = e.target.closest(".store-list-item");
      const storeName = itemNode ? itemNode.dataset.storeName : null;
      trackAnalyticsEvent("phone_clicked", { storeName });
    }
  });

  document.getElementById("use-my-location-btn").onclick = () => {
    showResults(
      `<div class="notice-box info">${preloaderSvg}<span>Finding your location...</span></div>`
    );
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) =>
          findStoresByLocation({
            latitude: pos.coords.latitude,
            longitude: pos.coords.longitude,
          }),
        () => {
          showResults(
            `<div class="notice-box info">${infoIconSvg}<span>Could not get your location. Please check browser permissions and try again.</span></div>`
          );
        }
      );
    } else {
      showResults(
        `<div class="notice-box info">${infoIconSvg}<span>Geolocation is not supported by your browser.</span></div>`
      );
    }
  };

  document.getElementById("address-input").addEventListener("keypress", function (e) {
    if (e.key === "Enter") {
      e.preventDefault();
      findStoresByLocation(this.value);
    }
  });

  function initAutocomplete() {
    if (typeof google === "undefined" || state.autocomplete) return;
    const input = document.getElementById("address-input");
    const options = {
      types: ["geocode"],
      componentRestrictions: { country: "ZA" },
    };
    state.autocomplete = new google.maps.places.Autocomplete(input, options);
    state.autocomplete.addListener("place_changed", () => {
      const place = state.autocomplete.getPlace();
      if (place.geometry && place.geometry.location) {
        findStoresByLocation({
          latitude: place.geometry.location.lat(),
          longitude: place.geometry.location.lng(),
          locality: formatLocalityFromComponents(place.address_components),
        });
      }
    });
  }
});
